/**
 * Opt-in backend cache modes for `$api` requests, passed as `{ awAxCache: … }`.
 * Each mode rewrites the outgoing URL (see `configureCache` in `./index.ts`) so
 * the backend caches the response under a key of a different granularity. Every
 * mode additionally varies by language.
 *
 * Efficiency increases {@link AW_AX_CACHE_DEFAULT} → {@link AW_AX_CACHE_SEGMENTATION}
 * → {@link AW_AX_CACHE_GLOBAL}. Pick the coarsest mode whose key the response
 * does not actually vary below, or users get stale data.
 */

/** Uses the full delivery params, so caches per delivery area. Least efficient: there can be thousands of them. */
export const AW_AX_CACHE_DEFAULT = Symbol('awAxCacheDefault');

/** Uses the segmentation code, which is company based. A handful of buckets, so fairly efficient. */
export const AW_AX_CACHE_SEGMENTATION = Symbol('awAxCacheSegmentation');

/** Uses nothing beyond language, so caches globally. Most efficient: one entry per language, shared by all users. */
export const AW_AX_CACHE_GLOBAL = Symbol('awAxCacheGlobal');

export type AwAxCache = (
  | typeof AW_AX_CACHE_DEFAULT
  | typeof AW_AX_CACHE_SEGMENTATION
  | typeof AW_AX_CACHE_GLOBAL
);

declare module 'axios' {
  interface AxiosRequestConfig {
    awAxCache?: AwAxCache;
  }
}
